import { Injectable } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BlockUserDTO, UserDTO } from '../models/user.model';
import { ResponseDTO } from '@app/shared/models/response.model';



@Injectable({
  providedIn: 'root'
})

export class UserService {
  PATH = 'api/users';

  constructor(private http: HttpClient) { }

  readonly usersResource = httpResource<UserDTO[]>(() => `${this.PATH}`);

  getUsersList(): Observable<UserDTO[]> {
    return this.http.get<UserDTO[]>(`${this.PATH}`);
  }

  addUser(user: UserDTO): Observable<ResponseDTO> {
    return this.http.post<ResponseDTO>(`${this.PATH}`, user);
  }

  getUser(userName: string): Observable<ResponseDTO> {
    return this.http.get<ResponseDTO>(`${this.PATH}/${userName}`);
  }

  blockUser(blockUserDTO: BlockUserDTO): Observable<boolean> {
    return this.http.put<boolean>(`${this.PATH}/block`, blockUserDTO);
  }

  updateUser(user: UserDTO): Observable<boolean> {
    return this.http.put<boolean>(`${this.PATH}`, user);
  }

  deleteUser(username: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.PATH}/${username}`);
  }

  sendVerifyEmail(username: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.PATH}/verify?username=${username}`, {});
  }

  refreshUsers(): void {
    this.usersResource.reload();
  }
}
